// src/components/LoadingSpinner.js
import React from 'react';
import PropTypes from 'prop-types';

const LoadingSpinner = ({ size = 'medium', message = 'Loading...' }) => {
    // Set size based on prop
    const sizeClass = {
        small: 'w-4 h-4',
        medium: 'w-8 h-8',
        large: 'w-12 h-12',
    }[size] || 'w-8 h-8';

    return (
        <div className="flex flex-col items-center justify-center">
            <div className={`${sizeClass} border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin`}></div>
            {message && <p className="mt-4 text-gray-600">{message}</p>}
        </div>
    );
};

LoadingSpinner.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    message: PropTypes.string,
};

export default LoadingSpinner;